const Marzipano = require('marzipano');

class Viewpoint {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.imgs = self.elem.dataset.images;
    }

    init() {
        let self = this;

        // Initialize Marzipano
        var viewer = new Marzipano.Viewer(self.elem);

        var levels = [
            { tileSize: 512, size: 512 },
            // { tileSize: 1024, size: 1024 }
        ];

        var geometry = new Marzipano.CubeGeometry(levels);
        var source = Marzipano.ImageUrlSource.fromString(self.imgs);

        var view = new Marzipano.RectilinearView();

        var scene = viewer.createScene({
            source: source,
            geometry: geometry,
            view: view
        });

        scene.switchTo();

        var controls = [
            { id: "left", label: "◀ Left", action: () => view.setYaw(view.yaw() - 0.1) },
            { id: "right", label: "Right ▶", action: () => view.setYaw(view.yaw() + 0.1) },
            { id: "up", label: "▲ Up", action: () => view.setPitch(view.pitch() - 0.1) },
            { id: "down", label: "Down ▼", action: () => view.setPitch(view.pitch() + 0.1) },
            { id: "zoomIn", label: "+ Zoom In", action: () => view.setFov(view.fov() - 5 * Math.PI / 180) },
            { id: "zoomOut", label: "- Zoom Out", action: () => view.setFov(view.fov() + 5 * Math.PI / 180) }
        ];

        // Create a container for controls
        var controlContainer = document.createElement("div");

        controlContainer.classList.add('viewpoint__controls');
        self.elem.appendChild(controlContainer);

        // Generate buttons dynamically
        controls.forEach(control => {
            var btn = document.createElement("button");

            btn.textContent = control.label;
            btn.addEventListener("click", control.action);
            controlContainer.appendChild(btn);
        });
    }
}

export default Viewpoint;
